'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import toast from 'react-hot-toast';
import {User} from "@/types/user";

interface BannedCheckProps {
    user: User | null; // Allow null
    children: React.ReactNode;
}

export default function BannedCheck({ user, children }: BannedCheckProps) {
    const router = useRouter();

    useEffect(() => {
        if (user && user.locked) {
            toast.error('Your account has been banned. Please contact support.');
        }
    }, [user, router]);

    // If user is banned and not an admin, show banned message
    if (user && user.locked && user.role !== 'admin') {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-900">
                <div className="max-w-md w-full p-8 text-center">
                    <div className="text-red-500 text-6xl mb-4">⛔</div>
                    <h1 className="text-2xl font-bold text-red-500 mb-4">Account Banned</h1>
                    <p className="text-gray-300 mb-6">
                        Your account has been banned. Please contact support for more information.
                    </p>
                </div>
            </div>
        );
    }

    return <>{children}</>;
}